<script setup>

import {__, _mareike_nonce, notify} from "../../../assets/javascripts/library";
import {ref} from "vue";
import Modal from "../../../assets/components/Modal.vue";
import { useAjax } from "../../../assets/javascripts/useAjax.js";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }, showCostUnit: Boolean
})

console.log(props.data);

const autoclose_date = ref(props.data.billing_deadline)
const notify_mail = ref(props.data.contact_email)
const mail_on_new = ref(Boolean(Number(props.data.mail_on_new)))
const distance_allowance = ref(props.data.distance_allowance)

const emit = defineEmits(['close'])

const { request } = useAjax()
console.log(mail_on_new);
function close() {
  emit('close')
}

async function updateCostUnit() {
  const formData = {
    billing_deadline: autoclose_date.value,
    contact_email: notify_mail.value,
    mail_on_new: mail_on_new.value,
    distance_allowance: distance_allowance.value,
  }

  const data = await request("/wp-json/mareike/costunits/update", {
    method: "POST",
    body: {
      mareike_nonce: _mareike_nonce(),
      cost_unit_id: props.data.id,
      cost_unit_data: formData
    }
  });

  notify(__('The cost unit was updated.', 'mareike'), 'success');
  close();
}

</script>

<template>

  <Modal
      :show="showCostUnit"
      :title="__('Change cost unit details', 'mareike')"
      @close="emit('close')"
  >
    {{__('Distance allowance', 'mareike') }}:
    <input type="number" class="mareike-text" style="width: calc(100% - 150px); margin-top: 10px;" id="distance_allowance" v-model="distance_allowance" step="0.01" /> Euro / km
    <br /><br />


    {{__('Close cost unit for new receipts on', 'mareike') }}:
    <input type="date" class="mareike-text" style="width: 100%; margin-top: 10px;" id="autoclose_date" v-model="autoclose_date" />
    <br /><br />
    {{__('Contact mail of treasurer', 'mareike') }}:
    <input type="email" class="mareike-text" style="width: 100%; margin-top: 10px;" id="contact_email" v-model="notify_mail" />
    <br /><br />
    
    <div style="margin-top: 10px;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input 
          type="checkbox" 
          id="mail_on_new" 
          v-model="mail_on_new"
          style="margin-right: 8px; cursor: pointer;"
        />
        <span>{{__('Send email notification on new receipts', 'mareike') }}</span>
      </label>
    </div>
    <br />

    <input type="button" class="mareike-button mareike-save-button" :value="__('Save changes', 'mareike')" @click="updateCostUnit" />
    
  </Modal>

</template>

<style>
.mareike-save-button {
  background-color: #2271b1 !important;
  color: #ffffff !important;
}
</style>